import 'styles/global.scss';
import 'styles/antd.scss';

import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { Affix } from 'antd';
import { BodyContainer } from 'components/home/App/components';
import CreditDetails from 'pages/CreditDetails';
import Error404 from 'pages/Error404';
import FlexContainer from 'components/common/FlexContainer';
import FullPageSpinner from 'components/common/FullPageSpinner';
import Header from 'components/layout/Header';
import Help from 'pages/Help';
import Home from 'pages/Home';
import RibbonHeader from 'components/layout/RibbonHeader';
import SavedCredits from 'pages/SavedCredits';
import SkipNav from 'components/common/SkipNav';
import { monsidoPages } from 'monsido/monsidoPages';
import { useEffect } from 'react';
import useIsAppLoaded from 'hooks/use-is-app-loaded';

const isMonsido = true;
export default function App(): JSX.Element {
  const isAppLoaded = useIsAppLoaded();
  // Scroll restoration on page transition
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
      activeElement.blur();
      const root = document.getElementById('root');
      if (root) {
        root.focus();
      }
    }
  }, [pathname]);

  if (!isAppLoaded) {
    return <FullPageSpinner />;
  }
  if (isMonsido) {
    return (
      <FlexContainer id='root'>
        <Affix>
          <SkipNav />
          <FlexContainer id='header'>
            <RibbonHeader />
            <Header />
          </FlexContainer>
        </Affix>
        <BodyContainer id='body'>
          <Routes>
            {monsidoPages.map((page) => {
              return <Route key={page.path} path={page.path} element={page.component} />;
            })}
            <Route key={'default'} path={'*'} element={<Navigate to={'/home'} replace />} />
          </Routes>
        </BodyContainer>
      </FlexContainer>
    );
  }

  return (
    <FlexContainer>
      <Affix>
        <SkipNav />
        <FlexContainer id='header'>
          <RibbonHeader />
          <Header />
        </FlexContainer>
      </Affix>
      <BodyContainer id='body'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/saved-credits' element={<SavedCredits />} />
          <Route path='/details/articulations/:creditItemID' element={<CreditDetails />} />
          <Route path='/details/precedents/:creditItemID' element={<CreditDetails />} />
          <Route path='/help' element={<Help />} />
          <Route path='*' element={<Error404 />} />
        </Routes>
      </BodyContainer>
    </FlexContainer>
  );
}
